import { emitEvent } from '@faceup/devtools'
import { httpAnalyzerName } from '@faceup/utils'
import { yup } from '@faceup/validation'

const yupSchema = yup.object({
  total: yup.number().required(),
  hits: yup.number().required(),
  miss: yup.number().required(),
})

const GLOBAL_HTTP_ANALYZER = {
  stats: {
    httpReqCount: 0,
    total: 0,
    hits: 0,
    miss: 0,
  },
  enable: (newValue = true) => {
    localStorage.setItem('enableHttpAnalyzer', newValue.toString())
  },
}

declare global {
  interface Window {
    GLOBAL_HTTP_ANALYZER: typeof GLOBAL_HTTP_ANALYZER
  }
}
window.GLOBAL_HTTP_ANALYZER = GLOBAL_HTTP_ANALYZER

const handleXRequestFaceUpTracingJSON = (x: string) => {
  const json = (() => {
    try {
      const result = yupSchema.validateSync(JSON.parse(x))
      return result
    } catch {
      return undefined
    }
  })()

  if (!json) {
    console.error(`Invalid ${httpAnalyzerName}`, x)
    return
  }

  window.GLOBAL_HTTP_ANALYZER.stats.httpReqCount += 1
  window.GLOBAL_HTTP_ANALYZER.stats.total += json.total
  window.GLOBAL_HTTP_ANALYZER.stats.hits += json.hits
  window.GLOBAL_HTTP_ANALYZER.stats.miss += json.miss

  const enabledCount =
    window.GLOBAL_HTTP_ANALYZER.stats.hits + window.GLOBAL_HTTP_ANALYZER.stats.miss

  const dataToRender = [
    { label: 'Total requests', value: window.GLOBAL_HTTP_ANALYZER.stats.httpReqCount },
    {
      label: 'Cache enabled requests',
      value: `${enabledCount}/${window.GLOBAL_HTTP_ANALYZER.stats.total}`,
    },
    { label: 'Cache hit', value: window.GLOBAL_HTTP_ANALYZER.stats.hits },
    ...(enabledCount > 0
      ? [
          {
            label: 'Cache hit ratio',
            value: `${((window.GLOBAL_HTTP_ANALYZER.stats.hits / enabledCount) * 100).toFixed(2)}%`,
          },
        ]
      : []),
  ]

  emitEvent('httpAnalyzer', dataToRender)
}

export const httpAnalyzer = {
  getIsEnabled: () => {
    const enableHttpAnalyzer = localStorage.getItem('enableHttpAnalyzer')
    return enableHttpAnalyzer === 'true'
  },
  handleXRequestFaceUpTracingJSON,
}

if (import.meta.env.VITE_ENVIRONMENT === 'development') {
  window.GLOBAL_HTTP_ANALYZER.enable(true)
}
